export default __webpack_public_path__ + "static/media/MyPlanimg1.cd3dda33.jpg";